import React, { useContext } from 'react';
import { NavbarContext } from './NavbarContext.js';
var lwLogoLightUrl = 'https://assets.lwolf.com/img/lw-logo-light.svg';
var lwLogoDarkUrl = 'https://assets.lwolf.com/img/lw-logo-dark.svg';
var lwLogoFallbackUrl = 'https://assets.lwolf.com/img/lw-logo.png';

var NavbarLogo = function NavbarLogo(_ref) {
  var applicationName = _ref.applicationName,
      linkWrapper = _ref.linkWrapper,
      appSwitcher = _ref.appSwitcher;

  var _useContext = useContext(NavbarContext),
      isDark = _useContext.isDark,
      logoUrl = _useContext.logoUrl,
      hideLogo = _useContext.hideLogo,
      hasBody = _useContext.hasBody;

  var logo = isDark ? lwLogoLightUrl : lwLogoDarkUrl;
  return React.createElement("div", {
    className: "helix-unified-navbar__logo-wrapper ".concat(hasBody ? 'helix-unified-navbar__logo-wrapper-with-body' : '')
  }, React.createElement(React.Fragment, null, !hideLogo && React.createElement("div", {
    className: 'helix-unified-navbar__logo'
  }, logoUrl ? React.createElement(React.Fragment, null, linkWrapper ? React.cloneElement(linkWrapper({
    url: logoUrl,
    logo: React.createElement("img", {
      className: 'logo logo-light',
      src: logo,
      onError: function onError(event) {
        var imageEvent = event.target;
        imageEvent.src = imageEvent.src === logo ? lwLogoFallbackUrl : '';
      },
      alt: 'Lone Wolf',
      width: '32',
      height: '32'
    })
  })) : React.createElement("a", {
    href: logoUrl
  }, React.createElement("img", {
    className: 'logo logo-light',
    src: logo,
    onError: function onError(event) {
      var imageEvent = event.target;
      imageEvent.src = imageEvent.src === logo ? lwLogoFallbackUrl : '';
    },
    alt: 'Lone Wolf',
    width: '32',
    height: '32'
  }))) : React.createElement("img", {
    className: 'logo logo-light',
    src: logo,
    onError: function onError(event) {
      var imageEvent = event.target;
      imageEvent.src = imageEvent.src === logo ? lwLogoFallbackUrl : '';
    },
    alt: 'Lone Wolf',
    width: '32',
    height: '32'
  })), applicationName && React.createElement("span", {
    className: 'helix-unified-navbar__application-name'
  }, applicationName), appSwitcher && appSwitcher));
};

export { NavbarLogo as default };